import React from 'react';

import { Formik } from 'formik';

import { isBrowserEnv } from 'modules/common/utils/env';
import { ITEM_FILTERS, ITEM_ORDER } from 'modules/item/utils/itemFilter';
import { useFiltersQuery } from 'modules/catalog/hooks/useFiltersQuery';

import { getFilterCount } from '../../utils/filterUtils';
import { ItemsFiltersDesktop } from './ItemsFiltersDesktop';
import { ItemsFiltersMobile } from './ItemsFiltersMobile';
import { MarketplaceAPI } from 'revibe-api';

type Props = {
  filters?: MarketplaceAPI.ItemFilters;
  type?: 'desktop' | 'mobile';
  onApply: (filters: MarketplaceAPI.ItemFilters) => void;
};

export const ItemsFilters = ({ type = 'mobile', onApply }: Props) => {
  const { filters, filtersQueryIsLoading } = useFiltersQuery();
  const initialValues = {
    [ITEM_FILTERS.IN_PREORDER]:
      filters[ITEM_FILTERS.IN_PREORDER] === 'true' || undefined,
    [ITEM_FILTERS.NOT_VERIFIED_ITEMS]:
      filters[ITEM_FILTERS.NOT_VERIFIED_ITEMS] === 'true' || undefined,
    [ITEM_FILTERS.SEX]: filters[ITEM_FILTERS.SEX] || undefined,
    [ITEM_FILTERS.SELLER]: filters[ITEM_FILTERS.SELLER] || null,
    [ITEM_FILTERS.SELLER_NAME]: filters[ITEM_FILTERS.SELLER_NAME] || null,
    [ITEM_FILTERS.SEARCH]: filters[ITEM_FILTERS.SEARCH] || undefined,
    [ITEM_FILTERS.COLLECTION]: filters[ITEM_FILTERS.COLLECTION] || undefined,
    [ITEM_FILTERS.CATEGORY]: filters[ITEM_FILTERS.CATEGORY] || undefined,
    [ITEM_FILTERS.SIZE]: filters[ITEM_FILTERS.SIZE] || '',
    [ITEM_FILTERS.MIN_PRICE]: filters[ITEM_FILTERS.MIN_PRICE] || undefined,
    [ITEM_FILTERS.MAX_PRICE]: filters[ITEM_FILTERS.MAX_PRICE] || undefined,
    [ITEM_FILTERS.ORDER]:
      filters[ITEM_FILTERS.ORDER] || ITEM_ORDER.MOST_RELEVANT,
    [ITEM_FILTERS.ONLY_SALES]: filters[ITEM_FILTERS.ONLY_SALES] || false,
  };
  const filtersCount = getFilterCount(initialValues);

  if (isBrowserEnv() && filtersQueryIsLoading) {
    return null;
  }

  if (type === 'desktop') {
    return (
      <Formik
        initialValues={initialValues}
        onSubmit={async (values) => {
          onApply({
            ...values,
          });
        }}
      >
        {() => <ItemsFiltersDesktop />}
      </Formik>
    );
  }

  return (
    <Formik
      initialValues={initialValues}
      onSubmit={async (values) => {
        onApply({
          ...values,
        });
      }}
    >
      {() => <ItemsFiltersMobile filtersCount={filtersCount} />}
    </Formik>
  );
};
